import { isPlatformBrowser, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, PLATFORM_ID, NgModule } from '@angular/core';

/* Create a new injection token for injecting the window into a component. */
const WINDOW = new InjectionToken('WindowToken');
/* Define abstract class for obtaining reference to the global window object. */
class WindowRef {
  get nativeWindow() {
    throw new Error('Not implemented.');
  }
}
/* Define class that implements the abstract class and returns the native window object. */
class BrowserWindowRef extends WindowRef {
  constructor() {
    super();
  }
  get nativeWindow() {
    return window;
  }
  static {
    this.ɵfac = function BrowserWindowRef_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrowserWindowRef)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BrowserWindowRef,
      factory: BrowserWindowRef.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BrowserWindowRef, [{
    type: Injectable
  }], () => [], null);
})();
/* Create an factory function that returns the native window object. */
function windowFactory(browserWindowRef, platformId) {
  if (isPlatformBrowser(platformId)) {
    return browserWindowRef.nativeWindow;
  }
  return new Object();
}
/* Create a injectable provider for the WindowRef token that uses the BrowserWindowRef class. */
const browserWindowProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef
};
/* Create an injectable provider that uses the windowFactory function for returning the native window object. */
const windowProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
  deps: [WindowRef, PLATFORM_ID]
};
/* Create an array of providers. */
const WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];
class WindowModule {
  static {
    this.ɵfac = function WindowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WindowModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WindowModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [WINDOW_PROVIDERS],
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WindowModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      providers: [WINDOW_PROVIDERS]
    }]
  }], null, null);
})();

/*
 * Public API Surface of window
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BrowserWindowRef, WINDOW, WINDOW_PROVIDERS, WindowModule, WindowRef, windowFactory };
